// src/app/store.js
import { configureStore } from "@reduxjs/toolkit";
import geoReducer from "../features/geo/geoSlice";
import locationReducer from "../features/location/locationSlice";
import indicesReducer from "../features/indices/indicesSlice";

const store = configureStore({
    reducer: {
        geo: geoReducer,
        location: locationReducer,
        indices: indicesReducer,
    },
    // GeoJSON objects can be large; disable serializable check for geo state
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredPaths: [
                    "geo.cache",
                    "geo.geojson",
                ],
            },
        }),
});

// Expose store on window for debugging when GEO_DEBUG is enabled
if (process.env.REACT_APP_GEO_DEBUG === "1") {
    window.store = store;
}

export default store;
